/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './TextLink.css';

import { colorClassNames, typography } from 'styles/styleUtility';

const TextLink = (props) => {
  const colorClassName = props.colorName ? colorClassNames.font(props.colorName) : null;
  const sizeClassName = props.size ? typography.font(props.size) : null;
  const styles = _.assign({}, {
    color: props.color ? `rgb(${props.color.r}, ${props.color.g}, ${props.color.b})` : null,
  }, props.style);
  return (
    <a href={props.href} target={props.isExternal && '__blank'} className={classnames(props.className, colorClassName, sizeClassName)} onClick={props.onClick} style={styles}>
      {props.children}
    </a>
  );
};
TextLink.propTypes = {
  size: typography.nameProp,
  colorName: colorClassNames.nameProp,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  isExternal: PropTypes.bool,
  color: PropTypes.shape({
    r: PropTypes.number.isRequired,
    g: PropTypes.number.isRequired,
    b: PropTypes.number.isRequired,
  }),
  style: PropTypes.object,
};
TextLink.defaultProps = {
  onClick: () => {},
  href: '#',
};

export default TextLink;
